/** Split a pasted list into options. Newline wins over comma, and a split is undoable — ADR-0003 §4. */
export function parseOptionPaste(text: string): string[] {
  const parts = text.includes('\n') ? text.split(/\r?\n/) : text.split(',');
  return parts.map((p) => p.trim()).filter(Boolean);
}

/** Shift an index-keyed sidecar (`option_media`, not the `choice_actions` array) — ADR-0003 §4. */
export function shiftIndexedEntries<T>(
  entries: Record<string, T> | undefined | null,
  fromIndex: number,
  delta: number,
): Record<string, T> | undefined {
  if (!entries || delta === 0) return entries ?? undefined;
  const moved: Record<string, T> = {};
  for (const [key, value] of Object.entries(entries)) {
    const index = Number(key);
    // A non-numeric key is not a position: carried through, never dropped.
    moved[Number.isNaN(index) || index < fromIndex ? key : String(index + delta)] = value;
  }
  return moved;
}

/** Open slots in a POSITIONAL array (`choice_actions`, not a map) on insert — ADR-0003 §4. */
export function spliceIndexedArray<T>(
  entries: T[] | undefined | null,
  fromIndex: number,
  delta: number,
): T[] | undefined {
  // Nothing after the insert point means nothing to move.
  if (!entries || delta <= 0 || fromIndex >= entries.length) return entries ?? undefined;
  const next = [...entries];
  next.splice(fromIndex, 0, ...(Array(delta).fill(undefined) as T[]));
  return next;
}
